import { Tag } from 'antd';
import moment from 'moment';
import '../../CSS/style.css';
import { connect } from 'react-redux';
import React, { Fragment, useState, useEffect, useCallback, useRef } from 'react';
import { config } from '../../constant';
import Truck from '../../Utils/images/Truck.jpg';
import ImageViewer from 'react-simple-image-viewer';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { ErrorComponent, NoRecordComponent } from '../../Utils';

const ImageGalleryWithPreview = (props) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [imagesList, setImagesList] = useState([]);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  let requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);
  const imageData = useCallback((imagesList) => {
    const images = imagesList.map(src => src.Value);
    setImages(images);
  }, []);

  const openImageViewer = (index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const getData = useCallback(async () => {
    requestCheck.current = false;
    let json = [];
    let errorInAPI = false;
    let noDataInDB = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = [
        { imageUrl: Truck },
        { imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeZeDQSmW4Nt9OH-zV4XSxOoS1GPPzD3wkAw&usqp=CAU' },
        { imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeZeDQSmW4Nt9OH-zV4XSxOoS1GPPzD3wkAw&usqp=CAU' },
        { imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRF1xnk8-XJgK2xFFRRNJhXfjXt5qDK1ab9FM8yv-Sx4CRszfP1ra-5OA7UW_UHWF2mQlU&usqp=CAU' }
      ];
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      if (json) {
        imageData(json);
        setImagesList(json);
        setCurrentImage(json[0].imageUrl);
        setRefreshDateTime(moment());
      }
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  }, [graphprops, props, imageData]);

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <div style={{ width: '100%' }}>
          <div style={{ width: '40%', float: 'left', margin: '5px 5px' }}>
            {imagesList && Array.isArray(imagesList) && imagesList.length > 0 && imagesList.map((src, index) => (
              <img
                src={src.imageUrl}
                onClick={() => openImageViewer(src.imageUrl)}
                width="50%"
                height="150"
                key={index}
                style={{ margin: '5px 0px', padding: '2px' }}
                alt=""
              />
            ))}
            {isViewerOpen && (
              <ImageViewer
                src={images}
                currentIndex={currentImage}
                onClose={closeImageViewer}
              />
            )}
          </div>

          <div style={{ float: 'left', width: '58%', marginTop: '10px' }}>
            <img src={currentImage} width="90%" height="300px" alt="" />
          </div>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(ImageGalleryWithPreview);